import { caseTypeCategory } from 'app/area/case/case-data-model';
import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { ComplexValue, ValueProperty } from 'ui';

export const riskValues = (caseState, uiEngineProps) => ({
  riskArea: resolvers.getComponentValues(caseState, uiEngineProps, 'RiskArea').valueItem,
  riskWeight: resolvers.getComponentValues(caseState, uiEngineProps, 'Weight').value,
  riskTrend: resolvers.getComponentValues(caseState, uiEngineProps, 'RiskTrend').valueItems
});

export interface RiskValueShape {
  riskArea: ComplexValue<number>;
  riskWeight: ValueProperty;
  riskTrend: ComplexValue<number>[];
  riskAreaRest: ComplexValue<number>;
  riskWeightRest: ValueProperty;
  riskTrendRest: ComplexValue<number>[];
}


export const bowtieSupported = (caseState, uiEngineProps) => ({
  bowtieSupported: 
    (resolvers.getComponentValues(caseState, uiEngineProps, 'ApplicationCategory').valueItem)?.value === caseTypeCategory.topevent
});
export interface BowtieSupportedShape {
  bowtieSupported: boolean;
}

export const residualRiskValues = (caseState, uiEngineProps) => ({
  riskAreaRest: resolvers.getComponentValues(caseState, uiEngineProps, 'RiskAreaResidual').valueItem,
  riskWeightRest: resolvers.getComponentValues(caseState, uiEngineProps, 'RiskWeightResidual').value,
  riskTrendRest: resolvers.getComponentValues(caseState, uiEngineProps, 'RiskTrendResidual').valueItems
});

